// Approval Type Constants
export const APPROVAL_TYPE = {
  JOB: 'job',
  OFFER: 'offer',
  REQUISITION: 'requisition',
} as const;

export const APPROVAL_TYPE_LABEL = {
  [APPROVAL_TYPE.JOB]: 'Job',
  [APPROVAL_TYPE.OFFER]: 'Offer',
  [APPROVAL_TYPE.REQUISITION]: 'Requisition',
} as const;

export type ApprovalType = typeof APPROVAL_TYPE[keyof typeof APPROVAL_TYPE];
